import { Box } from '@ovComponents/1-primative/box/box';
import pdfWorkerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';
import { useEffect } from 'react';
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;

export const PdfViewer = ({
  pdfUrl,
  onError,
  onFulfilled,
  fullWidth = false,
}: {
  pdfUrl?: string;
  onError?: (error?: any) => void;
  onFulfilled?: () => void;
  fullWidth?: boolean;
}) => {
  const renderPage = (pageNumber: number, canvas: any, pdf: any) => {
    pdf.getPage(pageNumber).then((page: any) => {
      const viewport = page.getViewport({ scale: 2 });
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      page.render({ canvasContext: canvas.getContext('2d'), viewport });
    });
  };

  const renderPdf = async () => {
    if (pdfUrl) {
      const loadingTask = pdfjs.getDocument(pdfUrl);
      loadingTask.promise.then(
        (pdf) => {
          const viewer = document.getElementById('pdf-viewer');
          while (viewer?.firstChild) {
            viewer?.removeChild(viewer?.firstChild);
          }
          let canvas1 = null;
          for (let page = 1; page <= pdf.numPages; page++) {
            canvas1 = document.createElement('canvas');
            canvas1.className = 'pdf-page-canvas';
            if (fullWidth) {
              canvas1.style.width = '100%';
            }
            viewer?.appendChild(canvas1);
            renderPage(page, canvas1, pdf);
          }
          if (onFulfilled) onFulfilled();
        },
        (error) => {
          if (onError) onError(error);
        },
      );
    }
  };

  useEffect(() => {
    if (pdfUrl) {
      renderPdf();
    }
  }, [pdfUrl]);

  return (
    <Box sx={{ lineHeight: 'inherit' }}>
      <div id='pdf-viewer'></div>
    </Box>
  );
};
